import { Component, Input, OnInit } from "@angular/core";

@Component({
  selector: "app-card-block-field",
  templateUrl: "./card-block-field.component.html",
  styleUrls: ["./card-block-field.component.scss"],
})
export class CardBlockFieldComponent implements OnInit {
  constructor() {}

  @Input() public header: string;

  ngOnInit(): void {}
}
